import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { adminSessionQueryOptions, meQueryOptions } from '@/query/query-options'
import { AdminSidebar } from './-components/admin-sidebar/admin-sidebar'

export const Route = createFileRoute('/(private)')({
	ssr: false,
	beforeLoad: async ({ context, location }) => {
		const session = await context.queryClient.fetchQuery(
			adminSessionQueryOptions()
		)

		if (session.sessionType !== 'authenticated') {
			throw redirect({
				to: '/login',
				search: { redirect: location.href }
			})
		}
	},
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(meQueryOptions()),
	component: () => (
		<AdminSidebar>
			<Outlet />
		</AdminSidebar>
	)
})
